import buildClickoutEvent from "../buildClickoutEvent";
import sendEvents from "../sendEvents";

export default function trackNonClickoutLinks(element: HTMLElement) {
  if (element.tagName === "A") {
    const href = element.getAttribute('href') || "";
    const separator = href.includes('?') ? '&' : '?';
    const sessionID = window.session_id ? `${separator}session=${window.session_id}` : "";
    element.setAttribute('href', href + sessionID);
    const Event = buildClickoutEvent(element);
    sendEvents(Event);
  }
}
